import React from "react";

export const Image4 = ({ title4, largeImage4, smallImage4 }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImage4} title4={title4} data-lightbox-gallery="gallery4">
          <div className="hover-text">
            <h4>{title4}</h4>
          </div>
          <img src={smallImage4} className="img-responsive" alt={title4} />{" "}
        </a>{" "}
        
      </div>
    </div>
    
  );
};
